import React from "react";
import NavBar from "../../components/NavBar.jsx";
import Footer from "../../components/Footer.jsx";
import Baseindex from "../../components/About/base.jsx";
import ChurnIndex from "../../components/Solution/Churn/ChurnIndex.jsx";

export default function Churn() {
  return (
    <div>
      {" "}
      <NavBar />/
      <ChurnIndex />
      <div className="pl-24 pr-24 content-start flex-col  p-4 justify-center  flex">
        <Baseindex />
      </div>
      <Footer />
    </div>
  );
}
